export const ExportImportDataMap = {
    EntitiesWithRelations: {
        classroom: {
            series: true,
            academic_level: true,
            courses: true
        },
        series: {
            department: true
        },
        department: {
            specialization: true
        },
        learner: {
            classroom: true,
        },
        course: {
            classroom: true,
            academic_level: true,
        },
        evaluation: {
            classroom: true,
            course: true,
            sequence: true,
            teachers: true
        },
        sequence: {
            semester: true,
        },
    }
    ,
    MapEntitiesToExport: {
        class: "classroom",
    },

    FieldsToOmit: {
        id: true,
        school_id: true,
        owner_id: true,
        created_at: true,
        updated_at: true,
        deleted_at: true,
        created_by: true,
        teachers_assigned: true,
        courses_assigned: true,
        app_user_id: true,
        role: true,
        grades: true,
        last_login_ip: true,
        last_login_location: true,
        messages: true,
        notifications: true,
        remember: true
    }
}